module.exports = __webpack_public_path__ + "img/frame-line.fe3d5fa3.png";